// Frontend-ready comments API adapter.
// Swap API_BASE to your server when ready. For now, it falls back to mock data.

import { mockComments } from '../data/mockData';

const API_BASE = process.env.REACT_APP_API_BASE || window.NUTRILENS_API_BASE || '';

const delay = (ms) => new Promise((r) => setTimeout(r, ms));

export async function listComments(recipeId) {
  if (API_BASE) {
    try {
      const res = await fetch(`${API_BASE}/recipes/${recipeId}/comments`);
      if (!res.ok) throw new Error('Failed to load comments');
      return await res.json();
    } catch (e) {
      console.warn('Falling back to mock comments due to API error:', e.message);
    }
  }
  await delay(200);
  return mockComments.filter((c) => c.recipeId === parseInt(recipeId, 10)).map((c) => ({ ...c, isLiked: false }));
}

export async function postComment(recipeId, { author, content }) {
  if (API_BASE) {
    const res = await fetch(`${API_BASE}/recipes/${recipeId}/comments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content }),
      credentials: 'include',
    });
    if (!res.ok) throw new Error('Failed to post comment');
    return await res.json();
  }
  await delay(250);
  return {
    id: Date.now(),
    recipeId: parseInt(recipeId, 10),
    author,
    content,
    timestamp: Date.now(),
    likes: 0,
    isLiked: false,
  };
}

export async function likeComment(recipeId, commentId, like = true) {
  if (API_BASE) {
    const res = await fetch(`${API_BASE}/recipes/${recipeId}/comments/${commentId}/like`, {
      method: like ? 'POST' : 'DELETE',
      credentials: 'include',
    });
    if (!res.ok) throw new Error('Failed to like/unlike comment');
    return await res.json();
  }
  await delay(150);
  return { success: true };
}

export async function postReply(recipeId, parentId, { author, content }) {
  if (API_BASE) {
    const res = await fetch(`${API_BASE}/recipes/${recipeId}/comments/${parentId}/replies`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content }),
      credentials: 'include',
    });
    if (!res.ok) throw new Error('Failed to post reply');
    return await res.json();
  }
  await delay(250);
  return {
    id: Date.now(),
    recipeId: parseInt(recipeId, 10),
    parentId,
    author,
    content,
    timestamp: Date.now(),
    likes: 0,
    isLiked: false,
  };
}

